import React, { useEffect, useState } from "react";
import {
  TextField,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import { getPets } from "../../../api/petService";

const PetAutocomplete = ({
  petId = "",
  value,
  onChange,
  label = "Select Pet",
  ...props
}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getPets();
        setItems(response?.data || []);
      } catch (error) {
        console.error("Error fetching items:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [petId]);

  return (
    <Autocomplete
      {...props}
      options={items}
      getOptionLabel={(option) => `${option.name} (${option.owner.last_name}, ${option.owner.first_name})` || ""}
      value={
        items.find((item) => item.id === value) || null
      }
      onChange={(event, newValue) =>
        onChange?.(newValue ? newValue.id : "")
      }
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default PetAutocomplete;